import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { ErrorBox, PageHead } from "../components/Bits";
import { Badge, Button, Card, Input, Tag } from "../design-system/components";
import { endpoints } from "../lib/api";
import { useSession } from "../lib/session";

export function SettingsPage() {
  const { user, profile } = useSession();
  const client = useQueryClient();
  const [handle, setHandle] = useState("");
  const handles = profile?.tcglHandles ?? [];
  const save = useMutation({
    mutationFn: (next: string[]) => endpoints.updateProfile(next),
    onSuccess: () => {
      setHandle("");
      void client.invalidateQueries({ queryKey: ["me"] });
    },
  });
  return (
    <div className="rk-stack">
      <PageHead
        title="Settings"
        subtitle="Your account comes from Play Rough Rankings; only Analytics preferences live here."
      />
      <div className="rk-split">
        <Card title="Account">
          <dl className="pr-kv">
            <dt>Name</dt>
            <dd>{user?.displayName}</dd>
            <dt>Email</dt>
            <dd>{user?.email}</dd>
            <dt>Role</dt>
            <dd>
              <Badge variant={user?.role === "admin" ? "accent" : "outline"}>{user?.role}</Badge>
            </dd>
            <dt>Games</dt>
            <dd>{profile?.gamesCount ?? 0}</dd>
          </dl>
        </Card>
        <Card
          title="TCG Live handles"
          description="Used to work out which side of a log is yours when the export doesn't say. Learned automatically from debug exports."
        >
          <div className="pr-inline" style={{ marginBottom: 12 }}>
            {handles.length === 0 && (
              <span className="pr-muted" style={{ fontSize: 14 }}>
                None yet
              </span>
            )}
            {handles.map((h) => (
              <Tag key={h} onRemove={() => save.mutate(handles.filter((x) => x !== h))}>
                {h}
              </Tag>
            ))}
          </div>
          <form
            className="pr-inline"
            onSubmit={(e) => {
              e.preventDefault();
              if (handle.trim()) save.mutate([...handles, handle.trim()]);
            }}
          >
            <div style={{ flex: 1, minWidth: 200 }}>
              <Input
                placeholder="In-game name, e.g. Sigma_E"
                value={handle}
                onChange={(e) => setHandle(e.target.value)}
              />
            </div>
            <Button type="submit" size="sm" disabled={save.isPending || handle.trim().length === 0}>
              Add
            </Button>
          </form>
          {save.error && (
            <div style={{ marginTop: 8 }}>
              <ErrorBox error={save.error} />
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}
